import styled from "styled-components";

import { colors, radii } from "shared/ui/tokens";

export const LanguageRow = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const PhotoRow = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const Preview = styled.img`
    width: 88px;
    height: 66px;
    flex: none;
    object-fit: cover;
    border-radius: ${radii.small};
    background: ${colors.segmentBg};
`;

export const VideoPreview = styled.video`
    width: 88px;
    height: 66px;
    flex: none;
    object-fit: cover;
    border-radius: ${radii.small};
    background: ${colors.segmentBg};
`;

export const NutritionBlock = styled.section`
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding-top: 14px;
    border-top: 1px solid ${colors.borderSoft};
`;

export const NutritionLabel = styled.p`
    margin: 0;
    font-size: 12px;
    color: ${colors.textSecondary};
`;
